import { render, staticRenderFns } from "./InfoPedido.vue?vue&type=template&id=52b7c8e8&scoped=true&"
import script from "./InfoPedido.vue?vue&type=script&setup=true&lang=js&"
export * from "./InfoPedido.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./InfoPedido.vue?vue&type=style&index=0&id=52b7c8e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b7c8e8",
  null
  
)

export default component.exports